import { createContext } from "react";

// @ts-ignore
export const engineContext = createContext()